import ListoryStore from '@/store';

export default class MapPositionHelper {
    public static restoreMapPosition(map: mapboxgl.Map, store: ListoryStore) {
        if (map && store.mapPosition) {
            map.setCenter(store.mapPosition.center);
            map.setZoom(store.mapPosition.zoom);
            map.setBearing(store.mapPosition.bearing);
        }
    }

    public static saveMapPosition(map: mapboxgl.Map, store: ListoryStore) {
        if (!map) return;

        store.mapPosition = {
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing()
        };
    }
}
